import { SharePointListClient, odataEscape, type ListItem } from '../SharePointListClient';

/**
 * `15.Descuentos` — one row per discounted line. Drives the monthly
 * allowance that PowerApps enforces (see `lib/discounts.ts`).
 *
 * `TipoDescuento_DESC` takes literal values:
 *   'Descuentos de Vendedores 5 Porc.',
 *   'Descuentos de Vendedores 10 Porc.',
 *   'Descuentos de Vendedores 15 Porc.',
 *   'Descuento Particular'.
 *
 * Note the percentage column is named `PorcentajeDescuento_C` (trailing
 * _C, not _DESC) on the live list — a legacy naming quirk. Dates use
 * the familiar `dd/mm/yyyy` / `mm/yyyy` string format.
 */
export type DescuentosFields = {
  Title?: string | null;
  VentaID_DESC?: string | null;
  DetalleID_DESC?: string | null;
  ArticuloID_DESC?: string | null;
  UsuarioID_DESC?: string | null;
  Vendedora_DESC?: string | null;
  TipoDescuento_DESC?: string | null;
  PorcentajeDescuento_C?: string | null;
  MontoTotal_DESC?: string | number | null;
  MontoDescontado_DESC?: string | number | null;
  Fecha_DESC?: string | null;
  Mes_DESC?: string | null;
  MesAnio_DESC?: string | null;
  Anio_DESC?: string | null;
  Hora_DESC?: string | null;
  Status_DESC?: 'Activo' | 'Pendiente Aprobacion' | 'Anulado' | string | null;
};

export type DescuentosItem = ListItem<DescuentosFields>;

export const descuentosClient = new SharePointListClient<DescuentosFields>('Descuentos');

/**
 * Month-scoped read for the allowance counters on Nueva Cotización.
 * `mesAnio` must be in `mm/yyyy` format.
 */
export async function listDescuentosByVendedorMes(
  vendedor: string,
  mesAnio: string,
): Promise<DescuentosItem[]> {
  return descuentosClient.listItems({
    filter:
      `fields/Vendedora_DESC eq ${odataEscape(vendedor)} and ` +
      `fields/MesAnio_DESC eq ${odataEscape(mesAnio)}`,
  });
}
